<template>
  <svg
    t="1712992154634"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3689"
  >
    <path
      d="M0 512a512 512 0 1 0 1024 0A512 512 0 0 0 0 512z"
      fill="#26BF4C"
      p-id="3690"
    ></path>
    <path
      d="M515.291429 240.932571c166.253714 0 300.982857 119.808 300.982857 267.556572S681.545143 776.045714 515.291429 776.045714a328.557714 328.557714 0 0 1-152.795429-37.010285c-21.357714-11.190857-130.633143 52.443429-148.187429 37.010285-19.894857-17.408 52.516571-114.395429 38.692572-136.192a243.785143 243.785143 0 0 1-38.692572-131.364571c0-147.748571 134.729143-267.556571 300.982858-267.556572zM615.643429 541.988571H414.939429c13.019429 44.617143 45.348571 66.925714 96.987428 66.925715 51.712 0 86.308571-22.308571 103.716572-66.852572z"
      fill="#FFFFFF"
      p-id="3691"
    ></path>
  </svg>
</template>
